import './Vendor/Hover';
import { Blocker } from './Vendor/Scrolly/Scrolly';

class Contact
{

    readonly overlay       :HTMLDivElement|null = null;

    private  dismiss       :HTMLButtonElement|null = null;
    private  scrollBlocker :Blocker;
    private  triggers      :NodeList|null = null;
    private  formFlyout    :HTMLFormElement|null = null;
    private  formMain      :HTMLFormElement|null = null;

    constructor()
    {

        // Blocker:

        this.scrollBlocker = Blocker.init();

        // Overlay:

        this.overlay = document.querySelector('#contact');
        if (!this.overlay) {
            return;
        }

        // Triggers:

        this.triggers = document.querySelectorAll('.page__contact > button, .navigation__button--contact, .page__main a[href*="/kontakt"]');
        this.triggers?.forEach((trigger :Node) :void => {
            (trigger as HTMLElement).addEventListener('click', (e :Event) :void => {
                e.preventDefault();
                this.scrollBlocker.on();
                this.overlay?.classList.add('-ready');
                setTimeout(() :void => {
                    this.overlay?.classList.add('-visible');
                }, 30);
            });
        });

        // Dismiss:

        this.dismiss = document.querySelector('.contact__dismiss');
        this.dismiss?.addEventListener('click', (e :Event) :void => {
            this.dismissOverlay();
        });

        // Forms:

        this.formMain = document.querySelector('.page__main form');
        this.formFlyout = this.overlay.querySelector('form');
        if (this.formMain) {
            const textArea :HTMLTextAreaElement|null = this.formMain.querySelector<HTMLTextAreaElement>('textarea');
            if (textArea) {
                textArea.placeholder = textArea.placeholder.replace(/\|/g, '\n');
            }
            this.formFlyout?.querySelectorAll<HTMLInputElement>('.form-element input')?.forEach((input :HTMLInputElement) :void => {
                const twin :HTMLInputElement|null = document.querySelector(`.page__main [id*="${input.id.replace('kontaktformular-74-', '')}"`);
                input.addEventListener('keyup', (e :Event) :void => {
                    if (twin) twin.value = input.value;
                });
            });
            this.formFlyout?.querySelector('.btn')?.addEventListener('click', (e :Event) :void => {
                e.preventDefault();
                this.dismissOverlay();
                setTimeout(() :void => {
                    document.querySelector('main')?.scrollIntoView();
                }, 500);
            });
        }

    }

    /**
     * Dismiss the overlay.
     */
    public dismissOverlay() :void {
        this.overlay?.classList.remove('-visible');
        setTimeout(() :void => {
            this.overlay?.classList.remove('-ready');
            this.scrollBlocker.off();
        }, 300);
    }

    /**
     * Init helper.
     */
    static init() :Contact
    {
        return new this();
    }

}

export default Contact;